import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageview } from '../lib/google_analytics'

const GoogleAnalytics = () => {
  const location = useLocation()

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      trackPageview(window.location.pathname + window.location.search)
    }
  }, [location.pathname])

  return null
}

export { GoogleAnalytics }
